import React from "react";
import { Popover, List, Typography, Divider } from "antd";
import {
  PhoneOutlined,
  InfoOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";

const wellnessContacts = [
  {
    title: "Tele MANAS (Govt. of India)",
    phone: "14416 / 1-800-891-4416",
    desc: "24/7, multiple languages, free",
  },
  // {
  //   title: "KIRAN (Ministry of Social Justice & Empowerment)",
  //   phone: "1800-599-0019",
  //   desc: "24/7, for mental illness",
  // },
  // {
  //   title: "NIMHANS (Psychological Support)",
  //   phone: "080-46110007",
  //   desc: "",
  // },
];

const wellnessResources = [
  {
    title: "UMMEED Guidelines (Draft)",
    link: "/pdf/Draft_UMMEED_Guielines.pdf",
  },
  {
    title: "National Suicide Prevention Strategy",
    link: "/pdf/National_Suicide_Prevention_Strategy.pdf",
  },
  {
    title: "Manodarpan Advisory for University Students",
    link: "/pdf/advisory_for_university_students_Manodarpan.pdf",
  },
];

export default function MentalWellnessVerticalStrip() {
  const content = (
    <div style={{ width: 300 }}>
      <Typography.Title level={5} style={{ textAlign: "center" }}>
        Mental Wellness Priority
        <br />
        <small>No Stigma in Seeking Help</small>
      </Typography.Title>

      {/* Helpline Numbers */}
      <List
        size="small"
        dataSource={wellnessContacts}
        renderItem={(item) => (
          <List.Item>
            <div>
              <Typography.Text strong>{item.title}</Typography.Text>
              <br />
              <a href={`tel:${item.phone.replace(/[^0-9]/g, "")}`}>
                <PhoneOutlined /> {item.phone}
              </a>
              {item.desc && (
                <div style={{ fontSize: 12 }}>{item.desc}</div>
              )}
            </div>
          </List.Item>
        )}
      />

      <Divider style={{ margin: "8px 0" }} />

      {/* PDF Resources */}
      <Typography.Text strong>Helpful Resources</Typography.Text>

      <List
        size="small"
        dataSource={wellnessResources}
        renderItem={(item) => (
          <List.Item>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <FilePdfOutlined style={{ color: "#ff4d4f" }} />
              {item.title}
            </a>
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="left">
      <div
        style={{
          position: "fixed",
          right: 0,
          top: "35%",
          zIndex: 1000,
          cursor: "pointer",
        }}
      >
        <div
          style={{
            backgroundColor: "#ff4d4f",
            color: "#fff",
            padding: "12px 10px",
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            fontWeight: 600,
            letterSpacing: 1,
          }}
        >
          <InfoOutlined style={{ marginBottom: 6 }} />
          Mental Wellness
        </div>
      </div>
    </Popover>
  );
}
